import { defineMessages } from "react-intl";

const messages = defineMessages({
    pitch: {
        id: "meta.pitch",
    },
    isSolfa: {
        id: "meta.isSolfa",
    },
    clef: {
        id: "meta.clef",
    },
    key: {
        id: "meta.key",
    },
    tonesetAbc: {
        id: "meta.toneset.abc",
    },
    tonesetSolfa: {
        id: "meta.toneset.solfa",
    },
    tonesetOnly: {
        id: "meta.toneset.only",
    },
    scale: {
        id: "meta.scale",
    },
    intervals: {
        id: "meta.intervals",
    },
    intervalsOnly: {
        id: "meta.intervals.only",
    },
    rangeSolfa: {
        id: "meta.range.solfa",
    },
    rangeAbc: {
        id: "meta.range.abc",
    },
    rangeInterval: {
        id: "meta.range.interval",
    },
});

export default messages;
